/*
 * Copyright (c) 2021 Mike Vo (info@miketvo.com) - All Rights Reserved.
 *
 * This file is part of the project "miketvo-website".
 *
 * This project is an online personal website by Mike Vo.
 *
 * COPYING AND/OR DISTRIBUTING OF ANY CONTENT WITHIN THIS PROJECT WITHOUT EX-
 * PRESS PERMISSION FROM THE CLIENT AND/OR THE AUTHOR, VIA ANY MEDIUM IS
 * STRICTLY PROHIBITED.
 *
 * Written by Mike Vo on June 27th 2021.
 *
 */

import * as React from "react";
import { graphql, useStaticQuery } from "gatsby";
import AniLink from "gatsby-plugin-transition-link/AniLink";

import Layout from "../../components/layout";
import Seo from "../../components/seo";
import SetLang from "../../components/setLang";
import Pagination from "../../components/pagination";
import * as headingStyle from "../../styles/heading.module.css";
import * as style from "../styles/blog.module.css";

const BlogPageZH = ({ location }) => {
  let data = useStaticQuery(graphql`
    query ChineseBlogQuery {
      site {
        siteMetadata {
          intl {
            lang
            blogTitle
          }
        }
      }
      allMarkdownRemark(sort: { fields: frontmatter___date, order: DESC }) {
        edges {
          node {
            id
            html
            frontmatter {
              path
              title
              date
              description
            }
          }
        }
      }
    }
  `);
  let intlData = data.site.siteMetadata.intl;
  let localizedData = intlData[0];
  for (let i = 0; i < intlData.length; i++) {
    if (intlData[i].lang === "zh") {
      localizedData = intlData[i];
      break;
    }
  }

  let markdownEdges = data.allMarkdownRemark.edges;
  let pages = [];
  let page = [];
  const pageSize = 4;
  markdownEdges.forEach((edge, count) => {
    page.push(edge.node);
    if ((count + 1) % pageSize === 0 || count + 1 === markdownEdges.length) {
      pages.push(page);
      page = [];
    }
  });
  let pageIndex = 0;
  if (location.state && location.state.pageIndex) pageIndex = location.state.pageIndex;
  let nextPageIndex = pageIndex + 1;
  let hasNextPage = nextPageIndex < pages.length;
  let prevPageIndex = pageIndex - 1;
  let hasPrevPage = prevPageIndex > -1;

  return (
    <Layout lang="zh">
      <Seo title="Blog" lang="zh" />
      <SetLang lang="zh" />
      <div className={style.wrapper}>
        <div
          data-sal="slide-down"
          data-sal-duration="1000"
          data-sal-delay="200"
          className={[headingStyle.dash, headingStyle.gradientYellowPurple].join(" ")}
        />
        <h1 data-sal="slide-down" data-sal-duration="1000" data-sal-delay="500">
          {localizedData.blogTitle}
        </h1>
        <Pagination
          location={"/blog/"}
          next={nextPageIndex}
          hasNext={hasNextPage}
          current={pageIndex}
          hasPrev={hasPrevPage}
          prev={prevPageIndex}
          pages={pages}
        />
        <div className={style.content}>
          {pages[pageIndex].map(node => {
            return (
              <div className={style.postBorder}>
                <div className={style.postBorderHighlight} />
                <div className={style.post}>
                  <div className={style.header}>
                    <div>
                      <div className={[headingStyle.dash, headingStyle.solidWhite].join(" ")} />
                      <div className="animated-anchor">
                        <AniLink cover direction="up" duration={1} bg="var(--light-black)" to={node.frontmatter.path}>
                          <h2>{node.frontmatter.title}</h2>
                        </AniLink>
                      </div>
                    </div>
                    <h3 className={style.date}>{node.frontmatter.date.split("T")[0]}</h3>
                  </div>
                  <p className={style.description}>{node.frontmatter.description}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </Layout>
  );
};

export default BlogPageZH;
